import { render, staticRenderFns } from "./ClubList.vue?vue&type=template&id=2c1f01ea&scoped=true"
import script from "./ClubList.vue?vue&type=script&lang=js"
export * from "./ClubList.vue?vue&type=script&lang=js"
import style0 from "./ClubList.vue?vue&type=style&index=0&id=2c1f01ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f01ea",
  null
  
)

export default component.exports